export default () => ({
  batteryContainer: {
    display: 'flex',
    alignItems: 'center'
  }
});
